import $ from "../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../libs/gsap/all.js"

export class Perso {

  // Constructor
  constructor(app) {
    this.getCurrentScreen = () => app.currentScreen;
    this.videos = [];
    this.currentVideo = null;

    $("#perso video").each((i, n) => {
      this.videos.push(n);
      n.addEventListener("ended", (event) => this.onVideoEnd());
    })
  }

  onVideoEnd() {
    const currentScreen = this.getCurrentScreen();
    const targetId = (currentScreen > 1 && this.videos.length > 1) ? 1 : 0;
    if (this.currentVideo === targetId) {
      this.videos[targetId].play()
    } else {
      this.switchVideo(targetId);
    }
  }

  switchVideo(targetId) {
    this.currentVideo = targetId;
    this.videos.forEach((video, vIndex) => {
      if (vIndex === targetId) {
        $(video).removeClass("hidden");
        video.play()
        video.addEventListener("play", (e) => {
          requestAnimationFrame(() => {
            // console.log("video switch to ", targetId)
            for (let i = 0; i < this.videos.length; i++) {
              if (i !== vIndex) {
                $(this.videos[i]).addClass("hidden");
                this.videos[i].currentTime = 0;
                this.videos[i].pause()
              }
            }
          })
        }, {once: true})
      } else {
        video.pause()
      }
    })
  }

}
